import { useState, useMemo, useEffect } from 'react';

export default function useIsInViewportById(id) {
  const [isIntersecting, setIsIntersecting] = useState(false);

  const observer = useMemo(() => {
    if (typeof window !== 'undefined' && 'IntersectionObserver' in window) {
      return new IntersectionObserver(([entry]) => setIsIntersecting(entry.isIntersecting));
    }
  }, []);

  useEffect(() => {
    const element = document.getElementById(id);
    if (element) observer.observe(element);

    return () => {
      observer.disconnect();
    };
  }, [observer, id]);

  return isIntersecting;
}
